import { RugbyLeagueEventDetailId } from '@collector/sportsapi-client-legacy'

import { EventInfoControls } from '../../../configuration'

export const eventInfoControls: EventInfoControls = [
  {
    control: 'Referee',
  },
  {
    grid: {
      cols: '2',
      controls: [
        {
          eventDetailId: RugbyLeagueEventDetailId.WeatherConditions,
          label: 'Weather cond.',
        },
        {
          eventDetailId: RugbyLeagueEventDetailId.PitchConditions,
          label: 'Pitch cond.',
        },
      ],
    },
  },
  {
    grid: {
      cols: '3',
      controls: [
        {
          eventDetailId: RugbyLeagueEventDetailId.PeriodLength,
          postfix: 'min',
        },
        {
          eventDetailId: RugbyLeagueEventDetailId.ExtraPeriodLength,
          label: 'Extra period',
          postfix: 'min',
        },
        {
          eventDetailId: RugbyLeagueEventDetailId.HasLineups,
        },
        'empty',
        'empty',
        'TeamColorsSwitch',
      ],
    },
  },
]
